<app-offline-banner></app-offline-banner>
<router-outlet></router-outlet>
